import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '@/components/index'
import contentsearch from '@/components/contentsearch'
import pressMedia from '@/components/pressMedia'
import editorReporter from '@/components/editorReporter'
import contentDetail from '@/components/contentDetail';
import pressMediaDetail from '@/components/pressMediaDetail'
import readMore from '@/components/readMore'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: index
  },
  {
    path: '/contentsearch',
    name: 'contentsearch',
    component: contentsearch
  },
  {
    path: '/pressMedia',
    name: 'pressMedia',
    component: pressMedia
  },
  {
    path: '/editorReporter',
    name: 'editorReporter',
    component: editorReporter
  },
  {
    path: '/contentName',
    name: 'contentName',
    component: contentsearch
  },
  {
    path: '/contentDepartment',
    name: 'contentDepartment',
    component: contentsearch
  },
  {
    path: '/contentSites',
    name: 'contentSites',
    component: contentsearch
  },
  {
    path: '/pressMedia/pressmediadetail',
    name: 'pressMediaDetail',
    component: pressMediaDetail,
    keepAlive: true
  },
  {
    path:'/contentsearch/contentDetail',
    name:'contentDetail',
    component:contentDetail,
    keepAlive: true
  },
  {
    path: '/reporters/reportersdetail',
    name: 'reportersDetail',
    component: pressMediaDetail,
    keepAlive: true
  },
  {
    path: '/readmore',
    name: 'readMore',
    component: readMore
  },
  {
    path:"/content_things/contentdetail",
    name:'contentthingsDatail',
    component: contentDetail
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(r => r.meta.requireAuth)) {
//     if (cookie.get('token')) {
//       next();
//     }
//     else {
//       next({
//         path: '/login',
//         query: { redirect: to.fullPath }
//       })
//     }
//   }
//   else {
//     next();
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js